﻿import init from "./init.js";
import updateValue from "./updateValue.js";
import toggleHighlight from "./toggleHighlight.js";
import destroy from "./destroy.js";

export default {
    init,
    updateValue,
    toggleHighlight,
    destroy,
}
